import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchSeminarer } from "../services/homeApi";
import Footer from "../components/Home/Footer";
import "./Seminarer.css";

function Seminarer() {
  const [seminars, setSeminars] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSeminarer()
      .then(setSeminars)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="sl-page">

      <div className="sl-header">
        <div className="sl-header-inner">
          <span className="sl-eyebrow">Al-Yasin Koranskole</span>
          <h1 className="sl-title">Seminarer</h1>
          <p className="sl-subtitle">
            Fordyp deg i kunnskap — meld deg på et av våre kommende seminarer
          </p>
        </div>
      </div>

      <div className="sl-body">
        <div className="sl-container">

          {loading && (
            <div className="sl-loading">
              <div className="spinner-border" style={{ color: "#d4af37" }} />
            </div>
          )}

          {!loading && seminars.length === 0 && (
            <div className="sl-empty">
              <span className="sl-empty-icon">🎓</span>
              <p>Ingen seminarer er planlagt ennå. Kom tilbake snart.</p>
            </div>
          )}

          {!loading && seminars.length > 0 && (
            <div className="sl-grid">
              {seminars.map((s) => {
                const dateObj = s.date ? new Date(s.date + "T00:00:00") : null;
                const day = dateObj ? dateObj.getDate() : "--";
                const month = dateObj ? dateObj.toLocaleString("no-NO", { month: "short" }).toUpperCase() : "";
                const weekday = dateObj ? dateObj.toLocaleString("no-NO", { weekday: "long" }) : "";

                return (
                  <div key={s.id} className="sl-card" onClick={() => navigate(`/seminarer/${s.id}`)}>
                    <div className="sl-card-date">
                      <span className="sl-date-day">{day}</span>
                      <span className="sl-date-month">{month}</span>
                    </div>

                    <div className="sl-card-body">
                      {weekday && <span className="sl-card-weekday">{weekday}</span>}
                      <h3 className="sl-card-title">{s.title}</h3>
                      {s.description && <p className="sl-card-desc">{s.description}</p>}
                      <div className="sl-card-meta">
                        {s.time && <span className="sl-chip">🕐 {s.time}</span>}
                        {s.location && <span className="sl-chip">📍 {s.location}</span>}
                        {s.speaker && <span className="sl-chip">🎤 {s.speaker}</span>}
                      </div>
                    </div>

                    <div className="sl-card-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Seminarer;
